const listaDeNotificacoesNaoLidas = (state) => {
    if (!state.notificacoes || !Array.isArray(state.notificacoes)) {
        return [];
    }
    return state.notificacoes;
}

const carregandoNotificacoes = (state) => {
    return state.carregando
}

export {
    listaDeNotificacoesNaoLidas,
    carregandoNotificacoes
}
